module.exports = __webpack_public_path__ + "img/3_user.d84a0554.svg";